import { ChangeDetectionStrategy, Component, ElementRef, viewChild } from '@angular/core';
// import { setInterval as wSetInterval, clearInterval as wClearInterval } from 'worker-timers';
import { SelectCameraInputButtonComponent } from '../../shared/new-slick/select-camera-input-button/select-camera-input-button.component';
import { fabric } from 'fabric'; // browser
import { NgZone } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-cpu',
  imports: [SelectCameraInputButtonComponent, MatTabsModule],
  templateUrl: './cpu.component.html',
  styleUrls: ['./cpu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class CPUComponent {
  readonly recordVideoElement = viewChild.required<ElementRef<HTMLVideoElement>>('recordedVideo');
  readonly videoInput = viewChild<ElementRef<HTMLVideoElement>>('videoInput');
  readonly fabricCanvas = viewChild<ElementRef<HTMLCanvasElement>>('fabricCanvas');
  readonly canvas = viewChild<ElementRef<HTMLCanvasElement>>('canvas');
  recordVideo!: HTMLVideoElement;
  isRecording: boolean = false;
  isVideo = false;
  isAnimationFrame = false;
  haveCanvas: boolean = false;
  haveFabricCanvas: boolean = false;
  videoStream!: MediaStream;
  audioStream!: MediaStream;
  combinedStream: MediaStream;
  recordedBlobs!: Blob[];
  mediaRecorder: any;
  downloadUrl!: string;
  fCanvas: fabric.Canvas;

  videoConstraints = {
    video: { width: 1280, height: 720 },
  };
  audioConstraints = {
    audio: { echoCancellation: true },
  };

  rawFrames = 0;
  workerFrames = 0;
  renderFrames = 0;
  canvasRefreshFrame = 0;
  fabricCanvasRefreshFrame = 0;
  lastRawTime = performance.now();
  lastWorkerTime = performance.now();
  lastRenderTime = performance.now();
  lastCanvasRenderTime = performance.now();
  lastFabricCanvasRenderTime = performance.now();
  rawFps = 0;
  workerFps = 0;
  renderFps = 0;
  targetFps: number = 30;
  recorderLoopInterval: number;
  canvasRefreshFps = 0;
  fabricCanvasRefreshFps = 0;

  frameCount = 0;
  startTime = Date.now();

  cameraDeviceId: string = '';
  canvasContext!: CanvasRenderingContext2D;

  canvasRefreshRate: number = 50;
  fabricCanvasRefreshRate: number = 50;
  filter = null;

  constructor(private ngZone: NgZone) {}

  async ngOnInit() {}

  async ngOnDestroy() {
    this.stopTracks();
    if (this.filter) {
      this.filter.destroy();
    }
    if (this.idx) {
      cancelAnimationFrame(this.idx);
    }
  }

  drawToCanvas() {
    this.ngZone.runOutsideAngular(() => {
      if (this.canvasContext) {
        this.canvasContext.drawImage(this.videoInput().nativeElement, 0, 0, 640, 360);
      } else {
        console.log('no canvasContext');
      }
    });
  }

  canvasTimerCallback() {
    //console.log('canvas timer callback');
    this.ngZone.runOutsideAngular(() => {
      const videoInput = this.videoInput();
      if (videoInput.nativeElement.paused || videoInput.nativeElement.ended || !this.haveCanvas) {
        console.log('paused or ended:', this.haveCanvas);
        return;
      }
      this.drawToCanvas();
      this.calculateCanvasFrameRate();
      setTimeout(() => {
        this.canvasTimerCallback();
      }, this.canvasRefreshRate);
    });
  }

  updateCanvasRefreshRate(event: any) {
    this.canvasRefreshRate = event.target.value;
  }

  updateFabricCanvasRefreshRate(event: any) {
    this.fabricCanvasRefreshRate = event.target.value;
  }

  fabricCanvasTimerCallback() {
    this.ngZone.runOutsideAngular(() => {
      const videoInput = this.videoInput();
      if (videoInput.nativeElement.paused || videoInput.nativeElement.ended || !this.haveFabricCanvas) {
        return;
      }
      this.drawToFabricCanvas();
      this.calculateFabricCanvasFrameRate();
      setTimeout(() => {
        this.fabricCanvasTimerCallback();
      }, this.fabricCanvasRefreshRate);
    });
  }

  async addCanvas() {
    const videoInput = this.videoInput();
    if (videoInput.nativeElement.paused || videoInput.nativeElement.ended) {
      return;
    }
    this.haveCanvas = !this.haveCanvas;
    this.createCanvas();
    this.ngZone.runOutsideAngular(() => {
      this.canvasTimerCallback();
    });
  }

  async addFabricCanvas() {
    const videoInput = this.videoInput();
    if (videoInput.nativeElement.paused || videoInput.nativeElement.ended) {
      return;
    }
    if (!this.canvasContext) {
      return;
    }
    this.haveFabricCanvas = !this.haveFabricCanvas;
    this.createFabricCanvas();
    this.ngZone.runOutsideAngular(() => {
      this.fabricCanvasTimerCallback();
    });
  }

  async createCanvas() {
    this.canvasContext = this.canvas().nativeElement.getContext('2d');
    this.canvasContext.drawImage(this.videoInput().nativeElement, 0, 0, 640, 360);
  }

  drawToFabricCanvas() {
    this.ngZone.runOutsideAngular(() => {
      const fabricObject = new fabric.Image(this.canvas().nativeElement, {
        backgroundColor: 'white',
        left: 0,
        top: 0,
        height: 360,
        width: 640,
        selectable: false,
      });
      this.fCanvas.add(fabricObject);
      this.fCanvas.bringToFront(fabricObject);
    });
  }

  createFabricCanvas() {
    this.fCanvas = new fabric.Canvas(this.fabricCanvas().nativeElement);
  }

  removeFabricCanvas() {
    this.haveFabricCanvas = false;
    this.fabricCanvasRefreshFps = 0;
    this.clearFabricCanvas();
    if (this.fCanvas) {
      this.fCanvas.dispose();
    }
  }

  async removeCanvas() {
    this.haveCanvas = false;
    this.canvasRefreshFps = 0;
    this.clearCanvas();
  }

  clearCanvas() {
    if (this.canvasContext) {
      this.canvasContext.clearRect(0, 0, this.canvas().nativeElement.width, this.canvas().nativeElement.height);
    }
    return;
  }

  clearFabricCanvas() {
    const fabricCanvas = this.fabricCanvas();
    if (fabricCanvas) {
      fabricCanvas.nativeElement
        .getContext('2d')
        .clearRect(0, 0, fabricCanvas.nativeElement.width, fabricCanvas.nativeElement.height);
    }
    return;
  }

  stopTracks() {
    if (this.videoStream) {
      this.videoStream.getTracks().forEach((track) => {
        track.stop();
      });
    }
    if (this.audioStream) {
      this.audioStream.getTracks().forEach((track) => {
        track.stop();
      });
    }
    if (this.combinedStream) {
      this.combinedStream.getTracks().forEach((track) => {
        track.stop();
      });
    }
  }

  async startVideo() {
    this.isVideo = true;
    this.getVideoStream();
    this.getAudioStream();
  }

  async stopVideo() {
    this.isVideo = false;
    this.reset();
  }

  idx: number;
  async startAnimationFrame() {
    console.log('starting animation frame');
    this.isAnimationFrame = true;

    this.ngZone.runOutsideAngular(() => {
      const loop = () => {
        if (!this.isAnimationFrame) {
          return;
        }
        this.idx = window.requestAnimationFrame(loop);
      };
      loop();
    });
  }

  async stopAnimationFrame() {
    this.isAnimationFrame = false;
    console.log(this.idx);
    // @ts-ignore
    window.cancelAnimationFrame(this.idx);
    // @ts-ignore
    console.log(this.idx);
    console.log('stopping animation frame');
  }

  changeBackground(background) {
    // @ts-ignore
    window.filter.changeBackground(document.getElementById('background' + background));
  }

  async getVideoStream() {
    const constraints: MediaStreamConstraints = {
      audio: false,
      video: {
        deviceId: this.cameraDeviceId,
        width: 640,
        height: 360,
      },
    };
    navigator.mediaDevices.getUserMedia(constraints).then(async (stream) => {
      this.videoStream = stream;
      this.recordVideo = this.recordVideoElement().nativeElement;
      this.videoInput().nativeElement.srcObject = this.videoStream;
    });
  }

  calculateCanvasFrameRate() {
    //console.log('calculateCanvasFrameRate');
    this.canvasRefreshFrame++;
    const now = performance.now();
    const elapsed = now - this.lastCanvasRenderTime;
    console.log('elapsed:', elapsed);
    if (elapsed >= 1000) {
      console.log('update:', this.canvasRefreshFrame);
      this.canvasRefreshFps = Math.round((this.canvasRefreshFrame * 1000) / elapsed);
      this.lastCanvasRenderTime = now;
      this.canvasRefreshFrame = 0;
    }
  }

  calculateFabricCanvasFrameRate() {
    this.fabricCanvasRefreshFrame++;
    const now = performance.now();
    const elapsed = now - this.lastFabricCanvasRenderTime;
    if (elapsed >= 1000) {
      this.fabricCanvasRefreshFps = Math.round((this.fabricCanvasRefreshFrame * 1000) / elapsed);
      this.lastFabricCanvasRenderTime = now;
      this.fabricCanvasRefreshFrame = 0;
    }
  }

  async getAudioStream() {
    navigator.mediaDevices.getUserMedia(this.audioConstraints).then((stream) => {
      this.audioStream = stream;
    });
  }

  // Combine video and audio tracks into a single MediaStream
  async combineStreams() {
    this.combinedStream = new MediaStream([
      ...this.videoStream.getVideoTracks(), // Add video tracks
      ...this.audioStream.getAudioTracks(), // Add audio tracks
    ]);
  }

  async startRecording() {
    console.log('startRecording');
    const videoInput = this.videoInput();
    if (videoInput.nativeElement.paused || videoInput.nativeElement.ended) {
      return;
    }
    if (this.recordVideoElement()) {
      this.recordVideo.src = '';
      this.recordVideo.srcObject = null;
      this.recordedBlobs = [];
      this.downloadUrl = '';
    }
    this.recordedBlobs = [];
    const options: any = { mimeType: 'video/webm' };

    try {
      await this.combineStreams();
      this.mediaRecorder = new MediaRecorder(this.combinedStream, options);
    } catch (err) {
      console.log(err);
    }

    this.mediaRecorder.start(); // collect 100ms of data
    this.isRecording = !this.isRecording;
    this.onDataAvailableEvent();
    this.onStopRecordingEvent();
  }

  stopRecording() {
    console.log('stopRecording');
    this.mediaRecorder.stop();
    this.isRecording = !this.isRecording;
    console.log('Recorded Blobs:', this.recordedBlobs);
  }

  reset() {
    if (this.recordVideoElement()) {
      this.recordVideo.src = '';
      this.recordVideo.srcObject = null;
    }
    this.stopTracks();
    this.isRecording = false;
    this.recordedBlobs = [];
    this.downloadUrl = '';
    this.videoInput().nativeElement.src = '';
    this.videoInput().nativeElement.srcObject = null;
    this.removeCanvas();
    this.removeFabricCanvas();
    this.canvasRefreshFps = 0;
    this.fabricCanvasRefreshFps = 0;
    this.canvasRefreshFrame = 0;
    this.fabricCanvasRefreshFrame = 0;
    this.videoStream = null;
  }

  onDataAvailableEvent() {
    try {
      this.mediaRecorder.ondataavailable = (event: any) => {
        if (event.data && event.data.size > 0) {
          this.recordedBlobs.push(event.data);
        }
      };
    } catch (error) {
      console.log(error);
    }
  }

  onStopRecordingEvent() {
    try {
      this.mediaRecorder.onstop = () => {
        const videoBuffer = new Blob(this.recordedBlobs, {
          type: 'video/webm',
        });
        this.downloadUrl = window.URL.createObjectURL(videoBuffer); // you can download with <a> tag
        this.recordVideo.src = this.downloadUrl;
      };
    } catch (error) {
      console.log(error);
    }
  }

  async updateDeviceId(device: MediaDeviceInfo) {
    this.cameraDeviceId = device.deviceId;
  }

  delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
